import React from 'react'
import { Link } from 'react-router-dom';
import Banner_01 from '../../../assets/images/about/about-user-1.png';
import Banner_02 from '../../../assets/images/about/about-user-2.png';
import Banner_03 from '../../../assets/images/about/about-user-3.png';
import Banner_04 from '../../../assets/images/about/about-user-4.png';
import Banner_05 from '../../../assets/images/about/about-user-5.png';
import Banner_06 from '../../../assets/images/about/about-three-image.jpg';

const Banner = () => {
    return (
        <>
            <div className="banner-section-three">
                <div className="container-fluid">
                    <div className="row gutter-y-15">
                        <div className="col-lg-6">
                            <div className="banner-left-three">
                                <div className="banner-heading-box-three">
                                    <h1>Empower your business to the Next level</h1>
                                </div>
                                <p className="lead-lg">
                                    Leverage agile frameworks to provide a robust synopsis for high
                                    level overviews. Iterative approaches to collaborative .
                                </p>
                                <div className="banner-details-three">
                                    <Link to="contact.html" className="btn btn-dark btn-theme">
                                        Get In Touch <span>+</span>
                                    </Link>
                                    <ul>
                                        <li>
                                            <img
                                                src={Banner_01}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Banner_02}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Banner_03}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Banner_04}
                                                alt="user-images"
                                            />
                                        </li>
                                        <li>
                                            <img
                                                src={Banner_05}
                                                alt="user-images"
                                            />
                                        </li>
                                    </ul>
                                    <p>250k+</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="banner-image-three">
                                <img
                                    src={Banner_06}
                                    alt="banner-image"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div >

        </>
    )
}

export default Banner
